import { ScheduleControl } from './schedulecontrol.model';

export class ScheduleControlResponse {
    scheduleControl: ScheduleControl;

    constructor(scheduleControl: ScheduleControl) {
        this.scheduleControl = scheduleControl;
    }
}
